import React from "react";

interface InputFieldProps {
  value: string;
  setValue: (value: string) => void;
  editable?: boolean;
  style?: React.CSSProperties;
}

const InputField: React.FC<InputFieldProps> = ({
  value,
  setValue,
  editable = true,
  style,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  if (!editable) {
    return <span style={style}>{value}</span>;
  }

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      style={style}
      onFocus={(e) => e.target.select()}
      onContextMenu={(e) => e.preventDefault()}
    />
  );
};

export default InputField;
